import React from 'react';
import PropTypes from 'prop-types';
import { StyledIconWrapper, StyledEmoji, StyledTitle } from './style';

const TitleEmoji = ({ emotion, text }) => (
  <StyledIconWrapper>
    <StyledEmoji emotion={emotion} />
    <StyledTitle>{text}</StyledTitle>
  </StyledIconWrapper>
);

TitleEmoji.propTypes = {
  emotion: PropTypes.oneOf(['neutro', 'triste', 'feliz', 'sorpresa', 'miedo']),
  text: PropTypes.string
};

export default TitleEmoji;
